"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const shims_1 = __importDefault(require("./shims"));
const compiler_1 = require("./compiler");
async function loadModule({ pools, functions, eelVersion = 2, }) {
    let compilerPools = {};
    Object.entries(pools).forEach(([key, globals]) => {
        compilerPools[key] = new Set(Object.keys(globals));
    });
    const buffer = compiler_1.compileModule({
        pools: compilerPools,
        functions,
        eelVersion,
    });
    const mod = await WebAssembly.compile(buffer);
    var importObject = Object.assign(Object.assign({}, pools), { shims: shims_1.default });
    return await WebAssembly.instantiate(mod, importObject);
}
exports.loadModule = loadModule;
//# sourceMappingURL=loader.js.map